import { iots } from '@code-expert/prelude';
import { CourseUrl, SemesterId, TaskId } from '/imports/domain';
import { end, formatRoute, lit, query, type, url } from '/imports/modules/Routing';
import { messagesSectionQuery } from '/imports/ui/pages/myCourses/messages/navigation';
import { Page } from './pages';

export const mycoursesSlug = 'mycourses';

const pageSlug = (p: Page) => url(base, lit(p));

const semester = type('semester', SemesterId);
const courseUrl = type('courseUrl', CourseUrl);
const page = type('page', Page);

//--------------------------------------------------------------------------------------------------

const myCourses = lit(mycoursesSlug);

export const myCoursesRoute = url(myCourses, end);
export const courseRoute = url(myCourses, semester, courseUrl, end);

const base = url(myCourses, semester, courseUrl);

//--------------------------------------------------------------------------------------------------

const analyticsSectionKeys = {
  groupAnalytics: null,
  groupOverview: null,
  jobFrequency: null,
  jobPerTask: null,
  highscore: null,
  data: null,
  submissions: null,
  presentations: null,
};

export type AnalyticsSection = keyof typeof analyticsSectionKeys;

const analyticsSection = iots.exact(
  iots.partial({
    section: iots.keyof(analyticsSectionKeys),
    highscoreChartSection: iots.string,
  }),
);

export const analyticsRoute = url(base, lit('analytics'), query(analyticsSection), end);

//--------------------------------------------------------------------------------------------------

export const appointmentsRoute = url(pageSlug('appointments'), end);
export const backupRoute = url(pageSlug('backup'), end);
export const codeExamplesRoute = url(pageSlug('codeExamples'), end);
export const exercisesRoute = url(pageSlug('exercises'), end);

//--------------------------------------------------------------------------------------------------

const groupsSectionKeys = {
  overview: null,
  import: null,
};

export type GroupsSection = keyof typeof groupsSectionKeys;

const groupsSection = iots.exact(iots.partial({ section: iots.keyof(groupsSectionKeys) }));

export const groupsRoute = url(pageSlug('groups'), query(groupsSection), end);

//--------------------------------------------------------------------------------------------------

const listInvitationsSectionKeys = {
  pending: null,
  archive: null,
};

export type ListInvitationsSection = keyof typeof listInvitationsSectionKeys;

const ListInvitationsSection: iots.Type<ListInvitationsSection> = iots.keyof(
  listInvitationsSectionKeys,
);

export const listInvitationsRoute = url(
  pageSlug('invitations'),
  type('section', ListInvitationsSection),
  end,
);

//--------------------------------------------------------------------------------------------------

export const ltiGradingRoute = url(pageSlug('ltiGrading'), end);
export const messagesRoute = url(pageSlug('messages'), messagesSectionQuery, end);
export const regradeRoute = url(pageSlug('regrade'), end);
export const regradeTaskRoute = url(pageSlug('regrade'), type('taskId', TaskId), end);
export const settingsRoute = url(pageSlug('settings'), end);
export const studentsRoute = url(pageSlug('students'), end);

export const courseEntryLink = formatRoute(courseRoute);
export const exercisesLink = formatRoute(exercisesRoute);
export const analyticsLink = formatRoute(analyticsRoute);
export const messagesLink = formatRoute(messagesRoute);
export const coursePageLink = formatRoute(url(base, page, end));
export const regradeTaskLink = formatRoute(regradeTaskRoute);
